import { render, staticRenderFns } from "./_detail.vue?vue&type=template&id=245fab42"
import script from "./_detail.vue?vue&type=script&lang=js"
export * from "./_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports